export const listType = function (list) {
  switch (Object.prototype.toString.call(list)) {
    case '[object Array]' :
      return 'array'
    case '[object Object]' :
      return 'object'
    case '[object NodeList]' :
      return 'nodes'
    default :
      return false
  }
}
export const arraysAreEqual = function (arOne, arTwo, orderMatters = false) {
  if (listType(arOne) !== 'array' || listType(arTwo) !== 'array') {
    return false
  }
  if (arOne.length !== arTwo.length) {
    return false
  }
  if (!orderMatters) {
    arOne.sort()
    arTwo.sort()
  }
  for (let i = 0, arrLength = arOne.length; i < arrLength; i++) {
    if (arOne[i] !== arTwo[i]) {
      return false
    }
  }
  return true
}

export const getQueryParams = function (passedWindow) {
  const currentWindow = window || passedWindow
  const query = currentWindow.location.search.substr(1)
  const queryParams = {}
  query.split('&').forEach(part => {
    const item = part.split('=')
    queryParams[item[0]] = decodeURIComponent(item[1])
  })
  return queryParams
}

export const generateVariableKey = function () {
  let result = ''
  const length = 8
  const characters = 'abcdefghijklmnopqrstuvwxyz'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}



// WEBPACK FOOTER //
// /app/js/utils.js